import { colors, getBorderRadius, getSpacing, getWidth } from '@cabonline/ui-shared';
import styled from '@emotion/styled';

import { StyledGoToContentButtonProps } from './types';

export const StyledGoToContentButton = styled.button<StyledGoToContentButtonProps>`
  visibility: ${(props) => (props.isButtonVisible ? 'visible' : 'hidden')};
  position: absolute;
  top: ${getSpacing('xs')};
  left: ${getSpacing('s')};
  background-color: ${colors.black};
  padding: ${getSpacing('s')};
  cursor: pointer;
  border-radius: ${getBorderRadius('m')};
  border: 1px solid ${colors.white};
  outline: none;
`;

export const StyledLayoutContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 ${getSpacing('m')};
  padding-bottom: ${getSpacing('l')};
  width: 100%;
`;

export const StyledLayoutMain = styled.main`
  width: 100%;
  max-width: ${getWidth('listContainer')};
  margin-top: ${getSpacing('m')};
`;
